import { WorkType } from '@adminModels';
import { WorkTypesQueryParams } from '@adminServices';
import { createAction, props } from '@ngrx/store';
import { PaginationMetadata } from '@shared';

export const ADMIN_WORK_TYPES_ID = '[Work Types admin]';

export const loadWorkTypes = createAction(
  ADMIN_WORK_TYPES_ID + ' Load Work Types',
  props<{ params?: WorkTypesQueryParams }>(),
);

export const loadWorkTypesSuccess = createAction(
  ADMIN_WORK_TYPES_ID + ' Load Work Types Success',
  props<{ workTypes: WorkType[]; pagination: PaginationMetadata }>(),
);

export const loadWorkTypesFailure = createAction(
  ADMIN_WORK_TYPES_ID + ' Load Work Types Failure',
  props<{ error: string }>(),
);

export const createWorkType = createAction(
  ADMIN_WORK_TYPES_ID + ' Create Work Type',
  props<{ workTypeData: CreateWorkTypeData }>(),
);

export const createWorkTypeSuccess = createAction(
  ADMIN_WORK_TYPES_ID + ' Create Work Type Success',
  props<{ workType: WorkType }>(),
);

export const createWorkTypeFailure = createAction(
  ADMIN_WORK_TYPES_ID + ' Create Work Type Failure',
  props<{ error: string }>(),
);

export const updateWorkType = createAction(
  ADMIN_WORK_TYPES_ID + ' Update Work Type',
  props<{ id: string; workTypeData: UpdateWorkTypeData }>(),
);

export const updateWorkTypeSuccess = createAction(
  ADMIN_WORK_TYPES_ID + ' Update Work Type Success',
  props<{ workType: WorkType }>(),
);

export const updateWorkTypeFailure = createAction(
  ADMIN_WORK_TYPES_ID + ' Update Work Type Failure',
  props<{ error: string }>(),
);

export const deleteWorkType = createAction(
  ADMIN_WORK_TYPES_ID + ' Delete Work Type',
  props<{ id: string }>(),
);

export const deleteWorkTypeSuccess = createAction(
  ADMIN_WORK_TYPES_ID + ' Delete Work Type Success',
  props<{ id: string }>(),
);

export const deleteWorkTypeFailure = createAction(
  ADMIN_WORK_TYPES_ID + ' Delete Work Type Failure',
  props<{ error: string }>(),
);

export interface CreateWorkTypeData {
  name: string;
  description: string;
  ratePointsPerHour: number;
  isActive?: boolean;
}

export interface UpdateWorkTypeData {
  name?: string;
  description?: string;
  ratePointsPerHour?: number;
  isActive?: boolean;
}
